import { Logo } from "@/components/Logo";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const FullLoader = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
    <Logo className="h-16 w-16 rounded-2xl animate-pulse" />
    <Loader2 className="h-6 w-6 animate-spin text-[#ccff0c]" />
  </div>
);

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/auth" state={{ from: location }} replace />;
  if (!user.profile_complete) return <Navigate to="/onboarding" replace />;
  return children;
};

// Requires authentication only (no profile-complete / paywall checks).
// Used for the onboarding route so a new user (profile_complete=false) can
// actually see the form instead of being redirected back to /onboarding forever.
export const AuthOnlyRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/auth" state={{ from: location }} replace />;
  return children;
};

export const PaidRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/auth" state={{ from: location }} replace />;
  if (!user.profile_complete) return <Navigate to="/onboarding" replace />;
  const active = user?.access?.active || user?.role === "admin";
  if (!active) return <Navigate to="/subscribe" replace />;
  return children;
};

export const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/auth" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};
